module.exports = __webpack_public_path__ + "static/media/mobile_Btn.d5bcde45.png";